import "./Decor.css"
import Product1 from "../Components/Product1"
import Alexa from "../images/alexa.jpg"
import Decor1 from "../images/hd1.webp"
import Decor2 from "../images/hd2.webp"
import Decor3 from "../images/hd3.webp"
import Decor4 from "../images/hd4.webp"
import Decor5 from "../images/hd5.webp"
import Decor6 from "../images/hd6.webp"
import Decor7 from "../images/hd7.webp"
import Decor8 from "../images/hd8.webp"
import Decor9 from "../images/decor.jpg"

export default function Decor() {

  return (
    <div className="stdivinhome">
     <div className="add"><img src={Decor9} /></div>
      
      <div className="home">
      
        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="decor1" prdName="Dell i5" img={Decor1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="decor2" prdName="Dell i7" img={Decor2} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="decor3" prdName="Hp i7" img={Decor3} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="decor4" prdName="Hp i5" img={Decor4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="decor5" prdName="Mack book " img={Decor5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="decor6" prdName="Mackbook 2" img={Decor6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="decor7" prdName="Mack book pro" img={Decor7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="decor8" prdName="Mack book pro" img={Decor8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}